import type { AccountPositionEvent } from "@/hooks/use-account-event-stream";
import type { StreamerMessage } from "@/services/account-streamer";
import { isPlainObject } from "@/hooks/types";

export interface AccountStreamMessageResult {
  accountNumber: string;
  publishedAt: number;
  message: StreamerMessage;
}

export function toStreamerMessageFromAccountEvent(
  event: AccountPositionEvent | undefined,
): AccountStreamMessageResult | null {
  if (!event) {
    return null;
  }

  const { accountNumber, payload } = event;
  if (!accountNumber) {
    return null;
  }

  if (!isPlainObject(payload)) {
    return null;
  }

  const record = payload as Record<string, unknown>;
  const symbolRaw = record.symbol;
  const symbol = typeof symbolRaw === "string" ? symbolRaw.trim() : "";

  if (!symbol) {
    return null;
  }

  const publishedAt = Number.isFinite(event.publishedAt)
    ? (event.publishedAt as number)
    : Date.now();

  const message: StreamerMessage = {
    type: "position",
    data: {
      ...record,
      symbol,
      "account-number": accountNumber,
    },
    timestamp: new Date(publishedAt).toISOString(),
  };

  return {
    accountNumber,
    publishedAt,
    message,
  };
}
